// Announcement bar: fades between messages one at a time. A message too long
// for one line starts left-aligned, pans to reveal its end, then fades out.
if (!customElements.get('tt-announcement-bar')) {
  const FADE_MS = 500;
  const PAN_PX_PER_SEC = 45;
  const PAN_PAUSE_MS = 1200;

  customElements.define(
    'tt-announcement-bar',
    class TTAnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.tt-ann__item'));
        if (!this.items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.holdMs = (parseFloat(this.dataset.duration) || 4) * 1000;
        this.paused = false;
        this.running = true;
        // Pause while the visitor is pointing at or focused on the bar.
        this.addEventListener('mouseenter', () => (this.paused = true));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));

        // Measure only once the web font is in: the fallback serif is wider and
        // would make a message that fits look like it overflows.
        (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => this.loop());
      }

      disconnectedCallback() {
        this.running = false;
      }

      wait(ms) {
        return new Promise((resolve) => {
          const tick = () => {
            if (!this.running) return;
            if (this.paused || document.hidden) return setTimeout(tick, 250);
            resolve();
          };
          setTimeout(tick, ms);
        });
      }

      async loop() {
        for (let i = 0; this.running; i = (i + 1) % this.items.length) {
          const item = this.items[i];
          const text = item.querySelector('.tt-ann__text');
          const viewport = item.querySelector('.tt-ann__viewport');

          text.style.transition = 'none';
          text.style.transform = '';
          item.classList.remove('is-overflowing', 'is-panned');
          item.classList.add('is-active');

          const overflow = Math.ceil(text.scrollWidth - viewport.clientWidth);
          if (overflow > 1) {
            item.classList.add('is-overflowing');
            await this.wait(PAN_PAUSE_MS);
            if (!this.running) return;
            const panMs = Math.max(1500, (overflow / PAN_PX_PER_SEC) * 1000);
            text.style.transition = `transform ${panMs}ms linear`;
            text.style.transform = `translateX(${-overflow}px)`;
            item.classList.add('is-panned');
            await this.wait(panMs + PAN_PAUSE_MS);
          } else {
            // A single message that fits has nothing to cycle to.
            if (this.items.length === 1) return;
            await this.wait(this.holdMs);
          }
          if (!this.running) return;

          item.classList.remove('is-active');
          await this.wait(FADE_MS);
        }
      }
    }
  );
}
